import React from "react";
import "./Skills.css";
const Skills = (props) => {
  return (
    <div className="skills" id="skills">
      <span className="header">
        <h4>MY SKILL</h4>
      </span>
      <div className="skillcontainer">
        <div className="left">
          <h6>BACKEND</h6>
          <div className="item">
            C
            <div class="progress-line c">
              <span></span>
            </div>
          </div>
          <div className="item">
            C++
            <div class="progress-line cplusplus">
              <span></span>
            </div>
          </div>
          <div className="item">
            Javascript
            <div class="progress-line javascript">
              <span></span>
            </div>
          </div>
          <div className="item">
            Node Js
            <div class="progress-line Nodejs">
              <span></span>
            </div>
          </div>
          <div className="item">
            Solidity
            <div class="progress-line solidity">
              <span></span>
            </div>
          </div>
        </div>
        <div className="right">
          <h6>FRONTEND</h6>
          <div className="item">
            HTML
            <div class="progress-line html">
              <span></span>
            </div>
          </div>
          <div className="item">
            CSS
            <div class="progress-line css">
              <span></span>
            </div>
          </div>
          <div className="item">
            Bootstrap
            <div class="progress-line javascript">
              <span></span>
            </div>
          </div>
          <div className="item">
            React
            <div class="progress-line react">
              <span></span>
            </div>
          </div>
          <div className="item">
            Redux
            <div class="progress-line redux">
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Skills;
